import Amenity from './Amenity'


export default Amenity
